import type { ISocketEventResponse } from "@/types/auth.interface";
import toast from "react-hot-toast";
import { socketManager } from "../socket-manager";
import { SOCKET_NAME_SPACES, SOCKET_SESSION_EVENTS } from "../socket.enum";
import { dispatchMaintenanceChanged } from "@/utils/maintenance-events";

export const initSessionListeners = (logoutUser: () => void) => {
  const sessionNamespace = SOCKET_NAME_SPACES.SESSIONS;
  // Session termination
  socketManager.on(
    sessionNamespace,
    SOCKET_SESSION_EVENTS.SESSION_TERMINATED,
    (payload: ISocketEventResponse, event: string) => {
      if (event === SOCKET_SESSION_EVENTS.SESSION_TERMINATED) logoutUser();
      toast.success(payload.message, {
        id: event,
      });
    },
  );

  // New device login
  socketManager.on(
    sessionNamespace,
    SOCKET_SESSION_EVENTS.NEW_DEVICE_LOGIN,
    (payload: ISocketEventResponse, event: string) => {
      toast.success(payload.message, {
        id: event,
      });
    },
  );

  // Maintenance mode changed — re-fetch status, update banner/fallback reactively
  socketManager.on(
    sessionNamespace,
    SOCKET_SESSION_EVENTS.MAINTENANCE_MODE_CHANGED,
    () => {
      dispatchMaintenanceChanged();
    },
  );
};
